export default function filterGlobalEmptyCategories(
  items,
  isGlobal = true,
  nameOfChildrenProperty = "children"
) {
  return items.filter((item) => {
    if (Array.isArray(item[nameOfChildrenProperty])) {
      item[nameOfChildrenProperty] = filterGlobalEmptyCategories(
        item[nameOfChildrenProperty],
        isGlobal,
        nameOfChildrenProperty
      )
    }

    if (item.global === isGlobal) {
      return true
    }

    return !Array.isArray(item[nameOfChildrenProperty]) || item[nameOfChildrenProperty].length > 0
  })
}
